import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CircleBar from './charts/CircleBar';
export const SetupOverview = ({ percentage, remaining, onOpenModal, style }) => {
    const { t } = useTranslation();
    return _jsxs("a", { className: 'setup setup--bottom-left', onClick: onOpenModal, style: style, children: [_jsx(CircleBar, { percentage: percentage, amount: remaining }), _jsxs("span", { className: 'setup__info', children: [_jsxs("span", { className: 'setup__title', children: [t('setup.title'), " ", t('siteName')] }), _jsx("span", { className: 'setup__description', children: t('setup.remainingTask', { count: remaining }) })] })] });
};
